import React, { Component } from 'react';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
import { Icon, Modal, Label } from "semantic-ui-react";
import Accordion from '@zippytech/react-toolkit/Accordion';
import '@zippytech/react-toolkit/Accordion/index.css';
import Summary from './Organization/Summary'
import UserCard from './Organization/UserCard'
import AddUnitUsers from '../../organization/drive/AddUsers'
import { connect } from 'react-redux';

@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Resource Pane")
})
class TeamMapping extends Component {

    constructor(props) {
        super(props);
        this.state = {
            openModalFlag: false
        }
    }

    componentWillMount() {

    }
    openModal() {
        this.setState({ openModalFlag: true })
    }
    closeModal() {
        this.setState({ openModalFlag: false })
    }

    render() {
        const expandTool = <div className="plusMinusIcons"  >
            <Icon className="close" name="plus circle" />
            <Icon className="open" name="minus circle" />
        </div>

        let counts = {}

        if (this.props.suborgDetails) {
            counts.usersLength = <Label>{this.props.suborgDetails && this.props.suborgDetails.data && this.props.suborgDetails.data.length}</Label>
        }

        return (
            <div className="accordianBox w_100">
                <div className="accordianPanel w_100">
                    <Accordion expandTool={expandTool} horizontal className="practiceFlowResourcePane" enableKeyboardNavigation={false}>
                        <div tabTitle="Team Summary">
                            <div className="acc-header">Team Summary</div>
                            <Summary {...this.props} />
                        </div>
                        <div tabTitle={
                            <div>
                                Users
                            {/* {counts.usersLength} */}
                            </div>}>
                            <div className="acc-header">Users
                                {/* {counts.usersLength} */}
                                <Icon style={{ cursor: "pointer" }} name='plus' color='green' onClick={() => this.openModal()} /></div>
                            <Modal
                                open={this.state.openModalFlag}
                                size='large'
                                closeOnEscape={false}
                                closeOnDimmerClick={false}
                            >

                                <Modal.Content>
                                    <Modal.Description>
                                        {this.props.suborgDetails && this.props.suborgDetails.data ?
                                            <AddUnitUsers
                                                history={this.props.history} {...this.props}
                                                searchUserArr={this.props.searchUserArr}
                                                searchInviteUserArr={this.props.searchInviteUserArr}
                                                selectedOrganisation={this.props.selectedOrganisation}
                                                selectedSubOrg={this.props.suborgDetails.data[0]}
                                                user={this.props.user}
                                                addUserContext={this.props.addUserContext}
                                                teamList={this.props.teamList}
                                                stringType="TeamMapping"
                                                onClose={() => this.closeModal()}
                                            /> : ''}

                                    </Modal.Description>
                                </Modal.Content>

                            </Modal>

                            <UserCard {...this.props} />
                        </div>

                    </Accordion>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {

    return {
        suborgDetails: state.initiatives.suborgDetails,
    };
}

const connectedTeamMapping = connect(mapStateToProps)(TeamMapping);

export default connectedTeamMapping;

